<template>
  <div class="bblayout">
    <div class="bblayout__content">
      <div class="simplecard">
        <div class="faq-item" :class="{ 'faq-item--open': item._open }" v-for="item in list" :key="item.id">
          <div class="faq-item__f" @click="switchOpen(item)">
            <div class="faq-item__f-text">
              {{ item.title }}
            </div>
          </div>
          <div class="faq-item__q">
            <div class="faq-item__q-text" v-for="text in (item.content || '').split('\n')" :key="text">{{ text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { getFAQ } from "@/api/faq";
import { Toast } from 'vant';
const list = ref([])
onMounted(() => {
  getFAQ().then(res => {
    if (res.data && res.data.code == '0') {
      list.value = res.data.body.map((v) => {
        v._open = false
        return v
      })
    } else {
      Toast('查询常见问题列表失败')
    }
  })
})
const switchOpen = (item) => {
  item._open = !item._open
  list.value.forEach(v => {
    if (v != item) {
      v._open = false
    }
  })
}
</script>
<style scoped>
.bblayout {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #0b0b0b;
}

.bblayout__content {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px 30px;
  box-sizing: border-box;
}

.bblayout__bottom {
  height: 90px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  border-top: 2px solid rgba(255, 255, 255, 0.1);
}

.simplecard {
  background: #171a1b;
  border-radius: 8px;
  position: relative;
  z-index: 1;
  padding: 0;
  overflow: hidden;
}

.faq-item__f {
  padding: 26px 30px;
  font-size: 28px;
  color: #FEFFFF;
  display: flex;
  align-items: flex-start;
}

.faq-item__f .faq-item__f-text {
  flex-grow: 1;
}

.faq-item__f::before {
  content: "Q：";
  color: #ff5841;
  flex-shrink: 0;
}

.faq-item__f::after {
  content: "";
  width: 10px;
  height: 10px;
  border-right: 1px solid #9DA2A5;
  border-bottom: 1px solid #9DA2A5;
  margin-left: 80px;
  flex-shrink: 0;
  margin-top: 10px;
  transform: rotate(45deg);
}

.faq-item:first-child {
  padding-top: 26px;
}

.faq-item:last-child:not(.faq-item--open) {
  padding-bottom: 26px;
}

.faq-item.faq-item--open .faq-item__f::after {
  margin-top: 14px;
  transform: rotate(-135deg);
}

.faq-item.faq-item--open .faq-item__q {
  display: block;
}

.faq-item.faq-item--open:last-child .faq-item__q {
  padding-bottom: 52px;
}

.faq-item__q {
  display: none;
  background: #232323;
  padding: 32px 30px;
  font-size: 24px;
  line-height: 48px;
  color: rgba(255, 255, 255, 0.8);
}

.faq-item__q .faq-item__q-text {
  min-height: 48px;
}

.faq-item__q .faq-item__q-text:first-child::before {
  content: "A：";
  color: #01B7A6;
  display: inline-block;
}
</style>
